import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDyiumw6LVQh7JcS0yQRSJQtgxGcBpZ27I",
  authDomain: "task-manager-6d4e3.firebaseapp.com",
  projectId: "task-manager-6d4e3",
  storageBucket: "task-manager-6d4e3.firebasestorage.app",
  messagingSenderId: "26447375535",
  appId: "1:26447375535:web:4cd2037326360a3a5c785a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);

export { auth, firestore };
